import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Typography, Box, IconButton, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub'; // Import GitHub icon
import logo from '../images/lg.png'; // Sesuaikan dengan jalur logo yang benar

const FooterContainer = styled('footer')(({ theme }) => ({
  backgroundColor: '#282c34', // Warna latar belakang modern
  padding: theme.spacing(4, 0),
  color: '#ffffff', // Warna teks putih
  marginTop: theme.spacing(4),
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#ffffff', // Warna tautan putih
  textDecoration: 'none',
  transition: 'color 0.3s ease',
  '&:hover': {
    color: theme.palette.primary.light, // Warna saat hover
  },
}));

const FooterSection = styled(Box)(({ theme }) => ({
  backgroundColor: '#1c1f24', // Warna latar belakang yang lebih gelap untuk bagian bawah footer
  padding: theme.spacing(4, 0),
  marginTop: theme.spacing(4),
}));

const SocialIconButton = styled(IconButton)(({ theme }) => ({
  color: '#ffffff', // Warna ikon putih
  transition: 'transform 0.3s ease, color 0.3s ease',
  '&:hover': {
    color: theme.palette.primary.light, // Warna saat hover
    transform: 'scale(1.2)', // Animasi memperbesar ikon saat dihover
  },
}));

const Footer = () => {
  return (
    <div>
      {/* Garis pembatas */}
      <Divider variant="middle" sx={{ marginBottom: 4, borderColor: '#ffffff' }} />

      <FooterSection>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <Box display="flex" flexDirection="column" alignItems="flex-start">
                <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '16px' }} />
                <Typography variant="body2" color="textSecondary" sx={{ color: '#aaaaaa' }}>
                  © 2024 ZodiakID. All Rights Reserved.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" gutterBottom sx={{ color: '#ffffff' }}>
                Zodiak More
              </Typography>
              <FooterLink to="/travel">Zodiak Love</FooterLink><br />
              <FooterLink to="/travel/tips">Zodiak Personality</FooterLink><br />
              <FooterLink to="/travel/stories">Tarot Reading</FooterLink>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" gutterBottom sx={{ color: '#ffffff' }}>
                Zodiak Reading
              </Typography>
              <FooterLink to="/zodiak/daily">Daily Readings</FooterLink><br />
              <FooterLink to="/zodiak/weekly">Weekly Readings</FooterLink><br />
              <FooterLink to="/zodiak/monthly">Monthly Readings</FooterLink>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="h6" gutterBottom sx={{ color: '#ffffff' }}>
                Social Media
              </Typography>
              <Box>
                <SocialIconButton href="https://www.facebook.com" aria-label="Facebook">
                  <FacebookIcon />
                </SocialIconButton>
                <SocialIconButton href="https://twitter.com" aria-label="Twitter">
                  <TwitterIcon />
                </SocialIconButton>
                <SocialIconButton href="https://www.instagram.com/herdiyanitdev/" aria-label="Instagram">
                  <InstagramIcon />
                </SocialIconButton>
                <SocialIconButton href="https://github.com/herdiyana256" aria-label="GitHub">
                  <GitHubIcon />
                </SocialIconButton>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </FooterSection>
    </div>
  );
};

export default Footer;
